import { useEffect } from 'react';
import s from './App.module.scss';

// import { Projects } from './components/Projects/Projects';
// import Header from './components/Header/Header';
import Experience from './components/Experience/Experience';
import Skills from './components/Skills/Skills';
import Footer from './components/Footer/Footer';
import Hero from './components/Hero/Hero';
import Education from './components/Education/Education';
import Interactive from './components/Interactive/Interactive';
import { useMedia } from './hooks/useMedia';

function App() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);
  const { isMobile } = useMedia();

  return (
    <div className={s.full_body}>
      {/*<Header />*/}
      <Hero />
      <Experience />
      <Education />
      {/*<Projects />*/}
      <Skills />
      <Footer />
      {!isMobile && <Interactive />}
    </div>
  );
}

export default App;
